import { render, staticRenderFns } from "./recipient-localphone.vue?vue&type=template&id=67b7c4eb"
import script from "./recipient-localphone.vue?vue&type=script&lang=js"
export * from "./recipient-localphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports